export const RollcallPunchesDayByDayReports = [
    {
      "s_no": 1,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/4/2025 10:01:23 AM"
    },
    {
      "s_no": 2,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/4/2025 9:20:30 PM"
    },
    {
      "s_no": 3,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/5/2025 10:07:43 AM"
    },
    {
      "s_no": 4,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/5/2025 9:28:31 PM"
    },
    {
      "s_no": 5,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/6/2025 10:05:49 AM"
    },
    {
      "s_no": 6,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/6/2025 9:40:16 PM"
    },
    {
      "s_no": 7,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/7/2025 9:50:51 AM"
    },
    {
      "s_no": 8,
      "employee": "Baji",
      "biometric_id": 1,
      "transaction_date": "3/7/2025 9:51:46 PM"
    }
  ]
  